import React, { Fragment } from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { PracticeMenuItem } from './PracticeMenuItem';
import { paths } from '../../../../routing/path';

export interface MyPracticesMenuItemProps {
    practices?: any[];
    headingClassName?: string;
    headingMarginLeft?: number;
    showHeading?: boolean;
}

export const MyPracticesMenuItem = (props: MyPracticesMenuItemProps) => {
    const practices = props.practices ?? [];
    const showHeading = props.showHeading ?? true;

    return (
        <Fragment>
            {showHeading && (
                <LeftMenuItem
                    icon="pe-7s-home"
                    label="My Practices"
                    to={paths.venues.grow.practices}
                    className={props.headingClassName}
                    marginLeft={props.headingMarginLeft}
                    trackingAction="My Practices"
                />
            )}
            {practices.map((practice, index) => (
                <PracticeMenuItem key={index} practice={practice} />
            ))}
        </Fragment>
    );
};
